<script>
  import { navigate } from "svelte-routing";
  import UserDropdown from "../Dropdowns/UserDropdown.svelte";
  import api from "../../services/api.js";

  let searchQuery = "";
  let searchResults = [];
  let searching = false;
  let showDropdown = false;

  async function handleSearch() {
    if (searchQuery.length < 1) {
      searchResults = [];
      showDropdown = false;
      return;
    }
    searching = true;
    showDropdown = true;
    try {
      const results = await api.searchStocks(searchQuery);
      searchResults = results || [];
    } catch (e) {
      console.error("Search error:", e);
      searchResults = [];
    }
    searching = false;
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (searchQuery && searchResults.length > 0) {
      selectStock(searchResults[0]);
    } else if (searchQuery) {
      navigate(`/admin/stock/${encodeURIComponent(searchQuery.toUpperCase())}`);
      showDropdown = false;
      searchQuery = "";
    }
  }

  function selectStock(stock) {
    showDropdown = false;
    searchQuery = "";
    navigate(`/admin/stock/${encodeURIComponent(stock.symbol)}`);
  }

  function handleBlur() {
    // Delay hiding dropdown to allow click events
    setTimeout(() => {
      showDropdown = false;
    }, 200);
  }
</script>

<header class="bg-surface border-b border-line sticky top-0 z-30">
  <div class="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center gap-4">
    <!-- Stock search -->
    <form on:submit={handleSubmit} class="relative flex-1 max-w-md">
      <span class="absolute left-4 top-1/2 -translate-y-1/2 text-ink-tertiary text-sm pointer-events-none">
        {#if searching}
          <i class="fas fa-spinner fa-spin"></i>
        {:else}
          <i class="fas fa-search"></i>
        {/if}
      </span>
      <input
        type="text"
        bind:value={searchQuery}
        on:input={handleSearch}
        on:focus={() => searchResults.length > 0 && (showDropdown = true)}
        on:blur={handleBlur}
        placeholder="Search stocks…"
        class="input !py-2.5 !pl-10"
      />

      {#if showDropdown && searchResults.length > 0}
        <div class="absolute top-full left-0 w-full card shadow-sm mt-2 max-h-72 overflow-y-auto z-50 py-1">
          {#each searchResults as stock}
            <button
              type="button"
              on:click={() => selectStock(stock)}
              class="w-full text-left px-4 py-2.5 hover:bg-canvas transition-colors"
            >
              <span class="text-sm font-semibold text-ink">{stock.symbol}</span>
              {#if stock.name}
                <span class="text-sm text-ink-secondary ml-2">{stock.name}</span>
              {/if}
              {#if stock.exchange}
                <span class="text-xs text-ink-tertiary ml-2">{stock.exchange}</span>
              {/if}
            </button>
          {/each}
        </div>
      {:else if showDropdown && searchQuery.length > 0 && !searching}
        <div class="absolute top-full left-0 w-full card shadow-sm mt-2 px-4 py-3 text-sm text-ink-tertiary z-50">
          No results for “{searchQuery}”
        </div>
      {/if}
    </form>

    <div class="ml-auto">
      <UserDropdown />
    </div>
  </div>
</header>
